import React, {FunctionComponent, useState} from 'react'
import ManageTarget from './ManageTarget/ManageTarget'
import style from './style.scss'
import {useTranslation} from 'react-i18next'
import {IProps} from './IProps'

const ManagePeriod: FunctionComponent<IProps> = ({targets, period}) => {
    const [t] = useTranslation()

    const targetsForPeriod = targets.filter(value => value.period === period)
    const manageTargets = targetsForPeriod.map(
        (value) => <ManageTarget key={value.id} target={value} />
    )

    return (
        <>
            <li className={style.manageCategory}>
                <div>
                    <p className={style.bold}>{t(`${period.charAt(0).toUpperCase() + period.slice(1)}`)}</p>
                    {targetsForPeriod.length >= 1
                        ? manageTargets
                        : (
                            <p>
                                {t('There are no targets for this period. Click on the "add target" button to do create one')}
                            </p>
                        )

                    }
                </div>
            </li>
            <hr className={style.hr} />
        </>
    )
}

export default ManagePeriod
